// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","undoButton":"UndoDiassociateProjectButton__undoButton--mM","loader":"UndoDiassociateProjectButton__loader--_X"};